import { fetchAuthSession, signOut } from 'aws-amplify/auth';

async function forceSignOut(): Promise<never> {
  try { await signOut(); } catch { /* ignore */ }
  window.location.href = '/';
  throw new Error('Session expired');
}

export async function fetchWithAuth(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  let session;
  try {
    session = await fetchAuthSession();
  } catch {
    return forceSignOut();
  }

  const token = session.tokens?.idToken?.toString();
  if (!token) return forceSignOut();

  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${token}`);

  return fetch(input, { ...init, headers });
}
